import {Component, OnInit, inject} from '@angular/core';
import {faEdit, faLock} from '@fortawesome/free-solid-svg-icons';
import {AuthenticationService} from '../_services/authentication.service';
import {Router, RouterLink} from '@angular/router';
import {I18nService} from '../_services/gui/i18n.service';
import {ActuatorService} from '../_services/data/actuator.service';
import {IconProp} from '@fortawesome/fontawesome-svg-core';
import {AppConfig} from '../_data/config/app-config';
import {NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, NgbDropdownButtonItem} from '@ng-bootstrap/ng-bootstrap/dropdown';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [RouterLink, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu, NgbDropdownItem, FaIconComponent, NgbDropdownButtonItem, TranslateModule]
})
export class HeaderComponent implements OnInit {
  i18nService = inject(I18nService);
  authService = inject(AuthenticationService);
  router = inject(Router);
  actuatorService = inject(ActuatorService);
  appConfig = inject(AppConfig);


  faLock = faLock as IconProp;
  faEdit = faEdit as IconProp;

  showVersion = !this.appConfig.production;
  uiVersion = this.appConfig.version;
  adminVersion: any;
  reportsVersion: any;

  headerRedirectUrl: string;
  userDisplayName: string;
  isUserLoggedIn: boolean;
  isUserPartiallyLoggedIn: boolean;

  public constructor() {
    this.authService.homePage$.subscribe(url => this.headerRedirectUrl = url);
    this.authService.userName$.subscribe(userName => {
      this.userDisplayName = userName;
    });

    //We want to know if a user has successfully STARTED to log in.
    //This will be used to show/hide the user drop down at all
    //Meaning they've done username/pass successfully and may or may not have finished MFA or first-time-user setup.
    this.authService.isUserPartiallyLoggedIn$.subscribe(b => {
      console.debug('Updated value for user partially logged in: ', b);
      return this.isUserPartiallyLoggedIn = b;
    });

    //Here we want to know if a user is FULLY logged in.
    //This will be used to show the edit-profile link.
    this.authService.isUserLoggedIn$.subscribe(b => this.isUserLoggedIn = b);
  }

  ngOnInit() {
    if(this.showVersion) {
      this.actuatorService.servicesInfo().subscribe(info => this.adminVersion = info?.build?.version);
      this.actuatorService.reportsInfo().subscribe(info => this.reportsVersion = info?.build?.version);
    }
  }

  public toggleEngFr() {
    this.i18nService.toggleEngFr();
  }

  logout(): void {
    this.authService.logout();
  }
}
